// Surfaces sync events as toasts. Lives inside both ConnectivityProvider
// and ToastProvider so it can subscribe to drain results from one and
// render messages through the other.

import { useEffect } from 'react';
import { useConnectivity } from '../context/ConnectivityContext';
import { useToast } from '../context/ToastContext';

export default function ConnectivityToastBridge() {
  const { registerDrainListener, retryNow } = useConnectivity();
  const { show } = useToast();

  useEffect(() => {
    return registerDrainListener((result) => {
      if (!result) return;
      if (result.rejected > 0) {
        show({
          message: result.rejected === 1
            ? 'A change couldn’t be saved.'
            : `${result.rejected} changes couldn’t be saved.`,
          durationMs: 6000,
        });
      }
      if (result.deferred > 0 && result.succeeded === 0) {
        show({
          message: result.deferred === 1
            ? 'Couldn’t sync 1 change. Will retry.'
            : `Couldn’t sync ${result.deferred} changes. Will retry.`,
          durationMs: 5000,
          action: { label: 'Retry', onClick: () => retryNow() },
        });
      }
    });
  }, [registerDrainListener, retryNow, show]);

  return null;
}
